class Scroller {

    scrollToElement(element, speed = 500) {
        if (element && !this.isInsideWindow(element)) {
            return this._scrollToElement(element, speed);
        }
        return Promise.resolve();
    }

    isInsideWindow(element) {
        let elementPosition = this.getElementDocumentPosition(element);
        console.log(elementPosition);
        let windowTop = document.documentElement.scrollTop || document.body.scrollTop;
        let windowBottom = windowTop + window.innerHeight;
        return windowTop <= elementPosition.top && windowBottom >= elementPosition.bottom;
    }

    getElementDocumentPosition(element) {
        let box = element.getBoundingClientRect();
        return {
            top: box.top + pageYOffset,
            bottom: box.bottom + pageYOffset,
        }
    }

    _scrollToElement(element, speed) {
        let moveToRect = element.getBoundingClientRect();
        let scrollTargetY = (moveToRect.top + pageYOffset) - window.innerHeight * 0.2;

        return new Promise(resolve => {
            const currentY = window.scrollY || document.documentElement.scrollTop;
            const time = Math.max(0.1, Math.min(Math.abs(currentY - scrollTargetY) / speed, 0.8));

            const easingFunction = function (pos) {
                return -0.5 * (Math.cos(Math.PI * pos) - 1);
            };

            let currentTime = 0;

            function tick() {
                currentTime += 1 / 60;

                let p = currentTime / time;
                let t = easingFunction(p);

                if (p < 1) {
                    requestAnimationFrame(tick);
                    window.scrollTo(0, currentY + (scrollTargetY - currentY) * t);
                    return;
                }

                window.scrollTo(0, scrollTargetY);
                resolve();
            }

            tick();
        });
    }
}

let instance = new Scroller();
export default instance;



// WEBPACK FOOTER //
// ./app/general/js/scroller.js